export const STORE_LOCATOR_FOCUS_RESULT_ATTR = 'data-fhs-store-locator-focus-result';

let shouldFocusFirstRestaurantResult = false;
let firstRestaurantFocusTarget: HTMLElement | null = null;
const focusRequestListeners = new Set<() => void>();

export function requestStoreLocatorFirstRestaurantFocus() {
  shouldFocusFirstRestaurantResult = true;
  focusRequestListeners.forEach(listener => {
    listener();
  });
}

export function hasPendingStoreLocatorFirstRestaurantFocus() {
  return shouldFocusFirstRestaurantResult;
}

export function clearStoreLocatorFirstRestaurantFocusRequest() {
  shouldFocusFirstRestaurantResult = false;
}

export function setStoreLocatorFirstRestaurantFocusTarget(target: HTMLElement | null) {
  firstRestaurantFocusTarget = target;
}

export function focusStoreLocatorFirstRestaurantResult() {
  const focusTarget =
    firstRestaurantFocusTarget && isFocusableTarget(firstRestaurantFocusTarget)
      ? firstRestaurantFocusTarget
      : findFirstRestaurantFocusTarget();

  if (!focusTarget) {
    return false;
  }

  focusTarget.focus({ preventScroll: true });
  clearStoreLocatorFirstRestaurantFocusRequest();
  return true;
}

export function subscribeStoreLocatorFirstRestaurantFocusRequest(listener: () => void) {
  focusRequestListeners.add(listener);
  return () => {
    focusRequestListeners.delete(listener);
  };
}

function isFocusableTarget(target: HTMLElement) {
  return (
    typeof document !== 'undefined' &&
    document.contains(target) &&
    !target.closest('[aria-hidden="true"], [inert]')
  );
}

function findFirstRestaurantFocusTarget() {
  if (typeof document === 'undefined') {
    return null;
  }

  return (
    Array.from(document.querySelectorAll(`[${STORE_LOCATOR_FOCUS_RESULT_ATTR}="true"]`)).find(
      (candidate): candidate is HTMLElement =>
        candidate instanceof HTMLElement && isFocusableTarget(candidate)
    ) ?? null
  );
}
